var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      ref: "dialog",
      attrs: { persistent: "", width: "290px" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-slide-x-transition",
                [
                  _c(
                    "v-text-field",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            value: _vm.formattedValue,
                            "persistent-hint": true,
                            readonly: "",
                          },
                        },
                        "v-text-field",
                        { ..._vm.$attrs, ...attrs },
                        false
                      ),
                      on
                    )
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialogOpen,
        callback: function ($$v) {
          _vm.dialogOpen = $$v
        },
        expression: "dialogOpen",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-date-picker",
        {
          attrs: {
            "allowed-dates": _vm.$attrs.allowedDates,
            scrollable: "",
            range: "",
          },
          on: { input: _vm.save },
          model: {
            value: _vm.model_local,
            callback: function ($$v) {
              _vm.model_local = $$v
            },
            expression: "model_local",
          },
        },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            { attrs: { text: "", color: "primary" }, on: { click: _vm.close } },
            [_vm._v("\n            Cancel\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }